export default "__VITE_ASSET__DUmUthyw__"